import { SelectOption } from '@src/common/types';

export function getActivityRangeDays(): SelectOption[] {
  return [
    // value is number of days
    { label: 'Last 24 Hours', value: '1' }, // 1 day
    { label: 'Last 3 Days', value: '3' }, // 3 days
    { label: 'Last 7 Days', value: '7' },
    { label: 'Last 14 Days', value: '14' },
    { label: 'Last 30 Days', value: '30' },
    { label: 'Last 60 Days', value: '60' },
    { label: 'Last 90 Days', value: '90' },
  ];
}
